module.exports = __webpack_public_path__ + "media/images/lb/380-72ad633edc2fc74b3267d7d5580b78ed.svg";